import { render, staticRenderFns } from "./messageNotice.vue?vue&type=template&id=537a9c26&"
import script from "./messageNotice.vue?vue&type=script&lang=js&"
export * from "./messageNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/messageNotice/messageNotice.vue"
export default component.exports